import React from 'react';
import { List, ListItem, ListItemText, Divider, Typography } from '@mui/material';

const ChatList = ({ chats, onChatSelect }) => {
  return (
    <div style={{ width: '100%', maxWidth: 360, backgroundColor: '#f5f5f5' }}>
      <Typography variant="h6" style={{ padding: '10px' }}>Chats</Typography>
      <List>
        {chats && chats.length>0 && chats.map((chat, index) => (
          <div key={index}>
            <ListItem button onClick={() => onChatSelect(chat)}>
              <ListItemText
                primary={chat.user.name}
                secondary={chat.message}
              />
            </ListItem>
            <Divider />
          </div>
        ))}
      </List>
    </div>
  );
};

export default ChatList;
